import React, { useEffect, useMemo } from 'react';
import { useSelector } from 'react-redux';
import FilterDropdown from '../../FilterDropdown/FilterDropdown';
import FilterButton from '../../FilterButton/FilterButton';
import useFilterState from '../../../hooks/useFilterState';
import { filtersData } from '../../../constants/filtersData';
import { filterNames } from '../../../constants/filterNames';
import getName from '../../../../../helpers/getName';
import FilterContainer from '../../FilterContainer/FilterContainer';
import SelectedOption from '../../SelectedOption/SelectedOption';
import WorkerWithPosition from '../../WorkerWithPosition/WorkerWithPosition';
import { generateCreateUsers } from './utils';
import { useFilterOptionsShorter } from '../../../hooks/useFilterOptionsShorter';
import { HiddenSelectedOptions } from '../../HiddenSelectedOptions/HiddenSelectedOptions';

const filter = filtersData[filterNames.createUsers];

const CreateUsersFilter = ({ disabled = false }) => {
  const filteredRequests = useSelector(
    (state) => state.statisticsStore.filteredRequests
  );

  const [filterState, setFilterState] = useFilterState(filter);
  const filterStateSet = new Set(filterState);
  const hasFilter = filterState.length > 0;

  const items = useMemo(() => {
    if (filteredRequests?.length) {
      const map = new Map();
      filteredRequests.forEach(generateCreateUsers(map));
      return Array.from(map.values()).sort((a, b) => b.amount - a.amount);
    }

    return [];
  }, [filteredRequests]);

  const handleItemRemove = (id) => {
    const newState = filterState.filter((itemId) => itemId !== id);
    setFilterState(newState);
  };

  useEffect(() => {
    if (items.length) {
      const setFilter = (prev) =>
        prev.filter((filterId) => items.some((item) => item.id === filterId));

      setFilterState(setFilter);
    }
  }, [items]);

  const filteredItems = items.filter((item) => filterStateSet.has(item.id));
  const { visibleItems, hiddenItems } = useFilterOptionsShorter(filteredItems);
  

  return (
    <FilterContainer>
      <FilterDropdown
        disabled={disabled}
        filter={filter}
        items={items}
        getItemContent={(item) => <WorkerWithPosition worker={item} />}
        getSearchContent={(item) => item.name || getName(item)}
        renderButton={({ visible }) => (
          <FilterButton
            text="Создатель"
            opened={visible}
            selected={hasFilter}
          />
        )}
      />
      {hasFilter &&
        visibleItems.map((item) => (
          <SelectedOption
            key={item.id}
            text={getName(item)}
            value={item.id}
            onRemove={handleItemRemove}
          />
        ))}
      {Array.isArray(hiddenItems) && !!hiddenItems.length && (
        <HiddenSelectedOptions
          hiddenItems={hiddenItems}
          handleItemRemove={handleItemRemove}
        />
      )}
    </FilterContainer>
  );
};

export default CreateUsersFilter;
